import { render } from "./SupportCases.vue?vue&type=template&id=1a57358c"
import script from "./SupportCases.vue?vue&type=script&lang=js"
export * from "./SupportCases.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__